import React from 'react';
import { Route, Switch } from 'react-router';
import FullScreenModalsLayout from '../layouts/full-screen-modals-layout';
import PaymentInfoLayout from '../layouts/with-payment-info-layout';
import AccountInfoView from '../views/modal-account-info/modal-account-info';
import PlayerLayout from '../layouts/player-layout';
import LightboxView from '../views/lightbox/lightbox-view';
import _ChannelInfoView from '../views/channel-info/channel-info-view';
import _ShareView from '../views/share/share-view';
import _PaymentView from '../views/payment/payment-view';

const withFullScreenModalsLayout = (Comp) => (props) =>
  (
    <FullScreenModalsLayout {...props}>
      {({ close }) => <Comp close={close} {...props} />}
    </FullScreenModalsLayout>
  );

const ShareView = withFullScreenModalsLayout(_ShareView);
const PaymentView = withFullScreenModalsLayout(_PaymentView);
const ChannelInfoView = withFullScreenModalsLayout(_ChannelInfoView);
const VideoOrChannelView = (isChannelView) => (routeProps) =>
  (
    <FullScreenModalsLayout {...routeProps}>
      {({ close }) => (
        <PlayerLayout
          close={close}
          {...routeProps}
          isChannelView={isChannelView}
        >
          <LightboxView
            close={close}
            {...routeProps}
            isChannelView={isChannelView}
          />
        </PlayerLayout>
      )}
    </FullScreenModalsLayout>
  );

export default (props) => {
  const getUrl = (url) => props.match.url + url;

  return (
    <Switch>
      <Route
        path={getUrl('account-info/:channelId')}
        render={(routeProps) => (
          <FullScreenModalsLayout {...routeProps}>
            {({ close }) => (
              <PaymentInfoLayout {...routeProps}>
                <AccountInfoView close={close} {...routeProps} />
              </PaymentInfoLayout>
            )}
          </FullScreenModalsLayout>
        )}
      />

      <Route
        path={getUrl('channel/:channelId/info')}
        component={ChannelInfoView}
      />
      <Route
        path={getUrl('channel/:channelId/share/:videoId?')}
        component={ShareView}
      />
      <Route
        path={getUrl('payment/:paymentType/video/:videoId')}
        component={PaymentView}
      />
      <Route
        path={getUrl('payment/:paymentType/:channelId/:videoId?')}
        component={PaymentView}
      />
      <Route
        path={getUrl('channel/:channelId/video/:videoId')}
        render={VideoOrChannelView(false)}
      />
      <Route
        path={getUrl('channel/:channelId')}
        render={VideoOrChannelView(true)}
      />
      <Route
        path={getUrl('video/:videoId')}
        render={VideoOrChannelView(false)}
      />
    </Switch>
  );
};
